export enum LegalType {
  AGB = 'agb',
  PRIVACY = 'privacy',
  IMPRINT = 'imprint',
  DIGITALDOCUMENTRECEIVAL = 'digitalDocumentsReceival',
  ACCESSIBILITY_DECLARATION = 'accessibilityDeclaration',
  CHATBOT_USAGE = 'chatbotUsage',
}
